function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.51569 18.15V18.9992H10.9893H19.4628V18.15V17.3008H10.9893H2.51569V18.15Z",
  fill: "#979797"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4537 2.2726C12.4465 2.27081 12.0971 2.36942 11.6774 2.49175C11.2576 2.61407 10.8781 2.73408 10.8339 2.75848C10.7764 2.79025 10.4135 3.90804 9.5513 6.70935C8.89001 8.85792 8.33067 10.6333 8.30834 10.6546C8.28595 10.6759 7.21715 11.0001 5.93312 11.375C4.64914 11.7499 3.51221 12.0955 3.40672 12.143C2.70021 12.4614 2.43798 13.4724 2.90545 14.0756C3.17406 14.4222 3.65782 14.6325 4.0853 14.5884C4.19088 14.5775 6.34452 13.9645 8.87113 13.2261C11.3977 12.4877 14.7006 11.5227 16.2107 11.0818L18.9564 10.2801L18.9625 10.1072C18.9902 9.31635 18.9542 5.80608 18.9183 5.8C18.8778 5.79315 17.7482 6.1156 17.696 6.1489C17.6846 6.15618 17.495 6.60837 17.2745 7.15378C17.0541 7.69924 16.8518 8.1588 16.825 8.17504C16.757 8.21644 12.5531 9.44423 12.5059 9.43654C12.4848 9.43306 12.4673 7.82051 12.4671 5.85304C12.4669 3.88559 12.4609 2.27437 12.4537 2.2726Z",
  fill: "#979797"
});

var SvgFlightLanding = function SvgFlightLanding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlightLanding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flight-landing.e2b73460.svg";
export { ForwardRef as ReactComponent };